export const firstLetterUppercase = (phrase: string) => {
	return phrase[0].toUpperCase() + phrase.slice(1);
};
